import Settings from "./components/Settings"

let module = "settings"

export default [{ path: "settings", component: Settings, meta: { module: module, permissions: ["setting-access"] } }]
